import { Place } from '~/models/Place'
import { GoogleRepository } from './repository'
import { MapLocation } from '~/services/map/types'
import { GooglePlace } from '~/models/GPlace'

export type MapFilter = {
	textKey: string
	types: string[]
	isActive?: boolean
	icon?: string
}
export class BrowserService {
	static async getPlacesPredictions(
		searchTerm: string,
		types?: string[],
		language?: string
	): Promise<GooglePlace[]> {
		return await GoogleRepository.findPlacesPredictions(searchTerm, types, language || 'en')
	}

	static async getPlaceInfo(placeId: string, language?: string): Promise<Place | undefined> {
		return await GoogleRepository.getPlaceInfo(placeId, language)
	}

	static getFilterCategories(): MapFilter[] {
		return [
			{
				textKey: 'discoverBlock_button_hotels',
				types: ['lodging'],
				icon: 'locatedBuilding',
			},
			{
				textKey: 'filterLabel_restaurants',
				types: ['restaurant'],
				icon: 'food',
			},
			{
				textKey: 'options_title_WhatToDo',
				types: [
					'tourist_attraction',
					'zoo',
					'aquarium',
					'garden',
					'botanical_garden',
					'planetarium',
					'plaza',
					'visitor_center',
					'observation_deck',
				],
				icon: 'camera-filled',
			},
			{
				textKey: 'filterLabel_museum',
				types: ['museum'],
				icon: 'culture',
			},
		]
	}

	static async getNearbySearch(
		types: string[],
		location: MapLocation,
		locale?: string
	): Promise<Place[]> {
		return await GoogleRepository.nearbyPlacesByTypes(types, location, locale)
	}
}
